module.exports = __webpack_public_path__ + "img/beautify.bc8ac7c3.svg";